//socket thị trường'


import { ENV } from '@/utilities/EWindow';
import { store } from '@/stores/dataStore/reduxStore/store';
import { updateInstruments, updateInstrumentsDict } from '@/stores/dataStore/reduxStore/symbol/symbolsSlice';
import { getConfigFromWindowBrowser } from '@/utilities';
import { difference, forEach, forIn, includes, remove } from 'lodash';
import io from 'socket.io-client';
// import { setupQueueProcess } from '@/utilities/queueProcess'
import { queueProcessCommon } from '@/utilities/queueProcess.ts'
// import { queueProcessCommon } from 'utils-package';
// import { Random } from 'utils-package';
// const queueProcess = setupQueueProcess()
const queueProcess = queueProcessCommon()

const MARKET_URL = getConfigFromWindowBrowser(ENV.API_MARKET_URL)

let sidSocket = undefined
export const socketRoomName = {
    'instrument': "i",    //room publish thông tin mã chứng khoán
    'exchange': "e",    //room publish thông tin mã chứng khoán
}

const socketAction = {    // socket action từ server trả về
    partial: "p",    // socket action partial
    update: "u",    // socket action update
    insert: "i",    // socket action insert
    delete: "d",    // socket action delete
    signal: "s",    // socket action signal
};

const SDK_INFO = {
    '__sails_io_sdk_version': '1.2.1',
    '__sails_io_sdk_platform': 'browser',
    '__sails_io_sdk_language': 'javascript',
};
//socket thị trường'
const socket = io(
    MARKET_URL, {
    path: '/market/socket.io',
    transports: ['websocket'],
    query: SDK_INFO,
    autoConnect: false
});

const queueTime = 0 // time call func queue
const timeoutEmit = 500; // timeout phản hồi từ server
let token = null;

const operationsQueue: any[] = [];

let subscribedTopics: any[] = [];
const registeredTopics: any = {};
const registeredCalledIds: any = {};

export const connect = () => {
    socket.open();
};

export const disconnect = () => {
    socket.close();
};

const _subscribeToTopics = (topics: string[]) => {
    try {
        if (!topics || topics.length === 0) {
            return false;
        }
        if (!socket.connected) {
            return false;
        }

        token = ""
        // https://socket.io/docs/v4/client-api/
        let data = {
            op: 'subscribe',
            args: topics,
            token: token,
        }
        socket.timeout(timeoutEmit).emit("get",
            {
                // url: '/client/send',
                url: '/client/subscribe', // Server xử lý Tuần tự
                method: 'get',
                headers: {

                },
                data: data
            }, (err: any, response: any) => {
                console.debug("socket.:_subscribeToTopics.:err,res=", err, response)
                return true;
            }
        );
    } catch (e) {
        console.debug("socket.:_subscribeToTopics.:err=", e)
        return false;
    }
    return true;
};

const _unsubscribeFromTopics = (topics: string[]) => {
    try {
        if (!topics || topics.length === 0) {
            return;
        }

        if (!socket.connected) {
            //console.log(TAG_NAME + 'Socket not ready, unsubscribe is skipped');
            return;
        }
        token = ""
        // https://socket.io/docs/v4/client-api/
        let data = {
            op: 'unsubscribe',
            args: topics,
            token: token,
        }
        socket.timeout(timeoutEmit).emit("get",
            {
                // url: '/client/send',
                url: '/client/subscribe', // Server xử lý Tuần tự
                method: 'get',
                headers: {},
                data: data
            }, (err: any, response: any) => {
                console.debug("socket.:_unsubscribeFromTopics.:err,res=", err, response)
                return true;
            });
    } catch (e) {
        console.debug("socket.:_unsubscribeFromTopics.:err=", e)
        return false;
    }
    return true;
};

// Clear callerId with empty topic and clear topic with empty callerId
const _prunce = () => {
    const willBeDeleteTopics: any[] = [];
    forIn(registeredTopics, (callerIds: any, topic: any) => {
        if (!callerIds || callerIds.length === 0) {
            willBeDeleteTopics.push(topic);
        }
    });
    forEach(willBeDeleteTopics as any[], (topic) => {
        delete registeredTopics[topic];
    });

    const willBeDeleteCallerIds: any[] = [];
    forIn(registeredCalledIds, (topics, callerId) => {
        if (!topics || topics.length === 0) {
            willBeDeleteCallerIds.push(callerId);
        }
    });
    forEach(willBeDeleteCallerIds, (callerId) => {
        delete registeredCalledIds[callerId];
    });
};

const _clearSubscribedTopics = () => {
    subscribedTopics.length = 0;
};

const _registerTopic = (topic: any, callerId: any) => {
    if (registeredTopics.hasOwnProperty(topic)) {
        const callerIds = registeredTopics[topic];
        if (!includes(callerIds, callerId)) {
            callerIds.push(callerId);
        }
    } else {
        registeredTopics[topic] = [callerId];
    }

    if (registeredCalledIds.hasOwnProperty(callerId)) {
        const topics = registeredCalledIds[callerId];
        if (!includes(topics, topic)) {
            topics.push(topic);
        }
    } else {
        registeredCalledIds[callerId] = [topic];
    }
    // console.log("_registerTopic", { topic, callerId, registeredTopics, registeredCalledIds })
};

const _unregisterTopic = (topic: any, callerId: any) => {
    if (registeredTopics.hasOwnProperty(topic)) {
        const callerIds = registeredTopics[topic];
        remove(callerIds, (element) => {
            return callerId === element;
        });
    }

    if (registeredCalledIds.hasOwnProperty(callerId)) {
        const topics = registeredCalledIds[callerId];
        remove(topics, (element) => {
            return topic === element;
        });
    }
};

const _unregisterTopics = (topics: any, callerId: any, dontCallApply?: any) => {
    //logDebug(`socket.:send.:${"_unregisterTopics"}`, { topics, callerId, dontCallApply })
    if (topics && topics.length > 0) {
        for (let i = 0; i < topics.length; i++) {
            _unregisterTopic(topics[i], callerId);
        }
    }
    _prunce();
    if (!dontCallApply) {
        _apply();
    }
};

const _unregisterCallerId = (callerId: any, dontCallApply: any) => {
    // console.log(`_unregisterCallerId 1`, { callerId, registeredCalledIds })
    if (registeredCalledIds.hasOwnProperty(callerId)) {
        const topics = registeredCalledIds[callerId];
        // console.log(`_unregisterCallerId 2`, { callerId, topics: topics })
        if (topics && topics.length > 0) {
            _unregisterTopics([...topics], callerId, dontCallApply);
        }
    }
};

const _registerTopics = (topics: any, callerId: any) => {
    // console.log(`socket.:send.:${"_registerTopics"}`, { topics, callerId })
    // Unregister all topic previously registered by this callerId
    _unregisterCallerId(callerId, true);
    if (topics && topics.length > 0) {
        for (let i = 0; i < topics.length; i++) {
            _registerTopic(topics[i], callerId);
        }
    }

    _apply();
};

const _apply = () => {
    let needToSubscribeTopics = [] as string[];
    forIn(registeredTopics, (callerIds, topic) => {
        if (callerIds.length > 0) {
            needToSubscribeTopics.push(topic);
        }
    });
    const willBeUnSubscribeTopics = difference(subscribedTopics, needToSubscribeTopics);
    _unsubscribeFromTopics(willBeUnSubscribeTopics);
    forEach(willBeUnSubscribeTopics, (topic) => {
        if (includes(subscribedTopics, topic)) {
            remove(subscribedTopics, (element) => {
                return element === topic;
            });
        }
    });

    const willBeSubscribeTopics = difference(needToSubscribeTopics, subscribedTopics);
    if (_subscribeToTopics(willBeSubscribeTopics)) {
        forEach(willBeSubscribeTopics, (topic) => {
            if (!includes(subscribedTopics, topic)) {
                subscribedTopics.push(topic);
            }
        });
    }
};


const _executeOperation = (operation: { action: string, data: any }) => {
    if (!operation) {
        console.error('Operation is undefined');
        return;
    }
    const { action, data } = operation;
    switch (action) {
        case 're-subscribe':
            _apply();
            break;
        case 'clear-subscribed':
            _clearSubscribedTopics();
            break;
        case 'register': {
            const { topics, callerId } = data;
            _registerTopics(topics, callerId);
            break;
        }
        case 'unregister': {
            const { topics, callerId } = data;
            _unregisterTopics(topics, callerId);
            break;
        }
        case 'unregister-callerId': {
            const { callerId } = data;
            _unregisterCallerId(callerId, false);
            break;
        }
        default:
            //console.log(TAG_NAME + 'Unknown socket action ' + action);
            break;
    }
};

const _requestReSubscribeToAllSubscribedTopics = () => {
    operationsQueue.push({
        action: 're-subscribe'
    });
};

const _requestClearSubscribedTopics = () => {
    operationsQueue.push({
        action: 'clear-subscribed'
    });
};

// Fired upon a connection including a successful reconnection
socket.on('connect', () => {
    sidSocket = socket && socket.id
    //logDebug(`socket.:on.:${"connect"}.:sid.:1=`, { sid: sidSocket })
    let _sidSocket = sessionStorage.getItem("sidSocket") || ""
    _sidSocket = _sidSocket + "||" + sidSocket
    sessionStorage.setItem("sidSocket", _sidSocket)
    _requestReSubscribeToAllSubscribedTopics();
});

// Fired upon a disconnection including a abnormal disconnection
socket.on('disconnect', () => {
    _requestClearSubscribedTopics();
});


// socket.on('connect_error', (err: any) => {
//     console.log(`socket.:on.:${"connect_error"}.:err=`, { err })
// });

socket.on('connect_failed', (err: any) => {

    console.log(`socket.:on.:${"connect_failed.:"}.:err=`, { err })
});

socket.on('reconnecting', () => {
});

socket.on(socketRoomName.instrument, (message: any) => {
    // isLogSocketFull && logDebug(`socket.:msg.:${socketRoomName.instrument}`, { message })
    let { a: action, d: data } = message;
    if (action === socketAction.update) {
        store.dispatch(updateInstruments(data));
        store.dispatch(updateInstrumentsDict(data))
    }
});


export const on = (eventName: string, eventHandler: (data: any) => void) => {
    socket.on(eventName, (data: any) => {
        eventHandler(data);
    })
};


// Fired upon a connection including a successful reconnection
socket.on('connect', () => {
    // console.log('connect.:')
    _requestReSubscribeToAllSubscribedTopics();
});

// Fired upon a disconnection including a abnormal disconnection
socket.on('disconnect', (reason) => {
    console.log('disconnect.:', reason)
    _requestClearSubscribedTopics();
});

socket.on('connect_failed', err => {
    console.log('connect_failed.:', err)
});

socket.io.on("reconnect_attempt", (attempt) => {
    console.log('reconnect_attempt.:', attempt)
});

socket.io.on("reconnect_error", (error) => {
    console.log('reconnect_error.:', error)

});

socket.io.on("reconnect_failed", () => {
    // console.log('reconnect_failed.:')

});

socket.on('reconnecting', () => {

});

socket.on('reconnect', () => {

})

export const registerTopics = (topics: string[], callerId: string) => {
    if (!callerId) {
        console.error('CallerId need when register interested topics');
        return;
    }
    let context = {
        action: 'register',
        data: {
            topics: topics,
            callerId: callerId
        }
    }
    // console.log("registerTopics.:context=", context, queueProcess)
    queueProcess.add(_executeOperation, context, queueTime)
};

export const unregisterTopics = (topics: string[], callerId: string) => {
    if (!callerId) {
        console.error('CallerId need when unregister interested topics');
        return;
    }
    let context = {
        action: 'unregister',
        data: {
            topics: topics,
            callerId: callerId
        }
    }
    queueProcess.add(_executeOperation, context, queueTime)
};


export const unregisterCallerId = (callerId: string) => {
    if (!callerId) {
        console.error('CallerId need when unregister interested topics');
        return;
    }
    let context = {
        action: 'unregister-callerId',
        data: {
            callerId: callerId
        }
    }
    queueProcess.add(_executeOperation, context, queueTime)
};

// Haki TEST socket instrument
let list = [
    "AAV",
    "ADC",
    "ALT",
    "AMC",
    "AME",
    "AMV",
    "API",
    "APS",
    "ARM",
    "ATS",
    "BAB",
    "BAX",
    "BBS",
    "BCC",
    "BCF",
    "BDB",
    "BED",
    "BKC",
    "BNA",
    "BPC",
    "BSC",
    "BST",
    "BTS",
    "BTW",
    "BVS",
    "BXH",
    "C69",
    "CAG",
    "CAN",
    "CAP",
    "CCR",
    "CDN",
    "CEO",
    "CET",
    "CIA",
    "CJC",
    "CKV",
    "CLH",
    "CLM",
    "CMC",
    "CMS",
    "CPC",
    "CSC",
    "CTB",
    "CTC",
    "CTP",
    "CTT",
    "CVN",
    "CX8",
    "D11",
    "DAD",
    "DAE",
    "DC2",
    "DDG",
    "DHP",
    "DHT",
    "DIH",
    "DL1",
    "DNC",
    "DNP",
    "DP3",
    "DPC",
    "DS3",
    "DST",
    "DTC",
    "DTD",
    "DTG",
    "DTK",
    "DVG",
    "DVM",
    "DXP",
    "EBS",
    "ECI",
    "EID",
    "EVS",
    "FBA",
    "FID",
    "GDW",
    "GIC",
    "GKM",
    "GLT",
    "GMA",
    "GMX",
    "HAD",
    "HAT",
    "HBS",
    "HCC",
    "HCT",
    "HDA",
    "HEV",
    "HGM",
    "HHC",
    "HJS",
    "HKT",
    "HLC",
    "HLD",
    "HMH",
    "HMR",
    "HOM",
    "HSA",
    "HTC",
    "HTP",
    "HUT",
    "HVT",
    "ICG",
    "IDC",
    "IDJ",
    "IDV",
    "INC",
    "INN",
    "IPA",
    "ITQ",
    "IVS",
    "KDM",
    "KHS",
    "KKC",
    "KMT",
    "KSD",
    "KSF",
    "KSQ",
    "KST",
    "KSV",
    "KTS",
    "KTT",
    "L14",
    "L18",
    "L40",
    "L43",
    "L61",
    "L62",
    "LAS",
    "LBE",
    "LCD",
    "LDP",
    "LHC",
    "LIG",
    "MAC",
    "MAS",
    "MBG",
    "MBS",
    "MCC",
    "MCF",
    "MCO",
    "MDC",
    "MED",
    "MEL",
    "MHL",
    "MKV",
    "MST",
    "MVB",
    "NAG",
    "NAP",
    "NBC",
    "NBP",
    "NBW",
    "NDN",
    "NDX",
    "NET",
    "NFC",
    "NHC",
    "NRC",
    "NSH",
    "NST",
    "NTH",
    "NTP",
    "NVB",
    "OCH",
    "ONE",
    "PBP",
    "PCE",
    "PCG",
    "PCH",
    "PCT",
    "PDB",
    "PEN",
    "PGN",
    "PGS",
    "PGT",
    "PHN",
    "PIA",
    "PIC",
    "PJC",
    "PLC",
    "PMB",
    "PMC",
    "PMP",
    "PMS",
    "POT",
    "PPE",
    "PPP",
    "PPS",
    "PPT",
    "PPY",
    "PRC",
    "PRE",
    "PSC",
    "PSD",
    "PSE",
    "PSI",
    "PSW",
    "PTD",
    "PTI",
    "PTS",
    "PV2",
    "PVB",
    "PVC",
    "PVG",
    "PVI",
    "PVS",
    "QHD",
    "QST",
    "QTC",
    "RCL",
    "S55",
    "S99",
    "SAF",
    "SCG",
    "SCI",
    "SD5",
    "SD6",
    "SD9",
    "SDA",
    "SDC",
    "SDG",
    "SDN",
    "SDU",
    "SEB",
    "SED",
    "SFN",
    "SGC",
    "SGD",
    "SGH",
    "SHE",
    "SHN",
    "SHS",
    "SJ1",
    "SJE",
    "SLS",
    "SMN",
    "SMT",
    "SPC",
    "SPI",
    "SRA",
    "SSM",
    "STC",
    "STP",
    "SVN",
    "SZB",
    "TA9",
    "TAR",
    "TBX",
    "TC6",
    "TDN",
    "TDT",
    "TET",
    "TFC",
    "THB",
    "THD",
    "THS",
    "THT",
    "TIG",
    "TJC",
    "TKG",
    "TKU",
    "TMB",
    "TMC",
    "TMX",
    "TNG",
    "TOT",
    "TPH",
    "TPP",
    "TSB",
    "TTC",
    "TTH",
    "TTL",
    "TTT",
    "TV3",
    "TV4",
    "TVC",
    "TVD",
    "TXM",
    "UNI",
    "V12",
    "V21",
    "VBC",
    "VC1",
    "VC2",
    "VC3",
    "VC6",
    "VC7",
    "VC9",
    "VCC",
    "VCM",
    "VCS",
    "VDL",
    "VE1",
    "VE3",
    "VE4",
    "VE8",
    "VFS",
    "VGP",
    "VGS",
    "VHE",
    "VHL",
    "VIF",
    "VIG",
    "VIT",
    "VKP",
    "VLA",
    "VMC",
    "VMS",
    "VNC",
    "VNF",
    "VNR",
    "VNT",
    "VSA",
    "VSM",
    "VTC",
    "VTH",
    "VTJ",
    "VTV",
    "VTZ",
    "WCS",
    "WSS",
    "X20"
]

list = [
    "AAA",
    "AAM",
    "AAT",
    "ABR",
    "ABS",
    "ABT",
    "ACB",
    "ACC",
    "ACG",
    "ACL",
    "ADG",
    "ADP",
    "ADS",
    "AGG",
    "AGM",
    "AGR",
    "ANV",
    "APG",
    "APH",
    "ASG",
    "ASM",
    "ASP",
    "AST",
    "BAF",
    "BBC",
    "BCE",
    "BCG",
    "BCM",
    "BFC",
    "BHN",
    "BIC",
    "BID",
    "BKG",
    "BMC",
    "BMI",
    "BMP",
    "BRC",
    "BSI",
    "BTP",
    "BTT",
    "BVH",
    "BWE",
    "C32",
    "C47",
    "CAV",
    "CCI",
    "CCL",
    "CDC",
    "CHP",
    "CIG",
    "CII",
    "CKG",
    "CLC",
    "CLL",
    "CLW",
    "CMG",
    "CMV",
    "CMX",
    "CNG",
    "COM",
    "CRC",
    "CRE",
    "CSM",
    "CSV",
    "CTD",
    "CTF",
    "CTG",
    "CTI",
    "CTR",
    "CTS",
    "CVT",
    "D2D",
    "DAG",
    "DAH",
    "DAT",
    "DBC",
    "DBD",
    "DBT",
    "DC4",
    "DCL",
    "DCM",
    "DGC",
    "DGW",
    "DHA",
    "DHC",
    "DHG",
    "DHM",
    "DIG",
    "DLG",
    "DMC",
    "DPG",
    "DPM",
    "DPR",
    "DQC",
    "DRC",
    "DRH",
    "DRL",
    "DSN",
    "DTA",
    "DTL",
    "DTT",
    "DVP",
    "DXG",
    "DXS",
    "DXV",
    "EIB",
    "ELC",
    "EVE",
    "EVF",
    "EVG",
    "FCM",
    "FCN",
    "FDC",
    "FIR",
    "FIT",
    "FMC",
    "FPT",
    "FRT",
    "FTS",
    "GAS",
    "GDT",
    "GEG",
    "GEX",
    "GIL",
    "GMC",
    "GMD",
    "GMH",
    "GSP",
    "GTA",
    "GVR",
    "HAG",
    "HAH",
    "HAP",
    "HAR",
    "HAS",
    "HAX",
    "HBC",
    "HCD",
    "HCM",
    "HCMA0307",
    "HDB",
    "HDC",
    "HDG",
    "HHP",
    "HHS",
    "HHV",
    "HID",
    "HII",
    "HMC",
    "HNA",
    "HNG",
    "HPG",
    "HPX",
    "HQC",
    "HRC",
    "HSG",
    "HSL",
    "HT1",
    "HTG",
    "HTI",
    "HTL",
    "HTN",
    "HTV",
    "HU1",
    "HUB",
    "HVH",
    "HVN",
    "HVX",
    "ICT",
    "IDI",
    "IJC",
    "ILB",
    "IMP",
    "ITA",
    "ITC",
    "ITD",
    "JVC",
    "KBC",
    "KDC",
    "KDH",
    "KHG",
    "KHP",
    "KMR",
    "KOS",
    "KPF",
    "KSB",
    "L10",
    "LAF",
    "LBM",
    "LCG",
    "LDG",
    "LEC",
    "LGC",
    "LGL",
    "LHG",
    "LIX",
    "LM8",
    "LPB",
    "LSS",
    "MBB",
    "MCP",
    "MDG",
    "MHC",
    "MIG",
    "MSB",
    "MSH",
    "MSN",
    "MWG",
    "NAB",
    "NAF",
    "NAV",
    "NBB",
    "NCT",
    "NHA",
    "NHH",
    "NHT",
    "NKG",
    "NLG",
    "NNC",
    "NO1",
    "NSC",
    "NT2",
    "NTL",
    "NVL",
    "NVT",
    "OCB",
    "OGC",
    "OPC",
    "ORS",
    "PAC",
    "PAN",
    "PC1",
    "PDN",
    "PDR",
    "PET",
    "PGC",
    "PGD",
    "PGI",
    "PGV",
    "PHC",
    "PHR",
    "PIT",
    "PJT",
    "PLP",
    "PLX",
    "PMG",
    "PNC",
    "PNJ",
    "POM",
    "POW",
    "PPC",
    "PSH",
    "PTB",
    "PTC",
    "PTL",
    "PVD",
    "PVP",
    "PVT",
    "QBS",
    "QCG",
    "QNP",
    "RAL",
    "RDP",
    "REE",
    "S4A",
    "SAB",
    "SAM",
    "SAV",
    "SBA",
    "SBG",
    "SBT",
    "SBV",
    "SC5",
    "SCD",
    "SCR",
    "SCS",
    "SFC",
    "SFG",
    "SFI",
    "SGN",
    "SGR",
    "SGT",
    "SHA",
    "SHB",
    "SHI",
    "SHP",
    "SIP",
    "SJD",
    "SJF",
    "SJS",
    "SKG",
    "SMA",
    "SMB",
    "SMC",
    "SPM",
    "SRC",
    "SRF",
    "SSB",
    "SSC",
    "SSI",
    "ST8",
    "STB",
    "STG",
    "STK",
    "SVC",
    "SVD",
    "SVI",
    "SVT",
    "SZC",
    "SZL",
    "TBC",
    "TCB",
    "TCD",
    "TCH",
    "TCI",
    "TCL",
    "TCM",
    "TCO",
    "TCR",
    "TCT",
    "TDC",
    "TDG",
    "TDH",
    "TDM",
    "TDP",
    "TDW",
    "TEG",
    "THG",
    "TIP",
    "TIX",
    "TLD",
    "TLG",
    "TLH",
    "TMP",
    "TMS",
    "TMT",
    "TN1",
    "TNA",
    "TNC",
    "TNH",
    "TNI",
    "TNT",
    "TPB",
    "TPC",
    "TRA",
    "TRC",
    "TSC",
    "TTA",
    "TTE",
    "TTF",
    "TV2",
    "TVB",
    "TVS",
    "TVT",
    "TYA",
    "UIC",
    "VAF",
    "VCA",
    "VCB",
    "VCF",
    "VCG",
    "VCI",
    "VDP",
    "VDS",
    "VFG",
    "VGC",
    "VHC",
    "VHM",
    "VIB",
    "VIC",
    "VIC11725",
    "VID",
    "VIP",
    "VIX",
    "VJC",
    "VMD",
    "VND",
    "VNE",
    "VNG",
    "VNL",
    "VNM",
    "VNS",
    "VOS",
    "VPB",
    "VPD",
    "VPG",
    "VPH",
    "VPI",
    "VPS",
    "VRC",
    "VRE",
    "VSC",
    "VSH",
    "VSI",
    "VTB",
    "VTO",
    "VTP",
    "YBM",
    "YEG"
]

list = ['AAS', 'HGP', 'SSI']
// list = ["ASG", "SSI","ASG", "SSI"]
const enableTestSocket = false
// let count = 0

let countSeqTest: any = {};       // countSeqTest Socket
setTimeout(() => {
    if (enableTestSocket) {
        setInterval(function () {
            let min = 120;
            let max = 400;
            let rand = (min + (Math.random() * (max - min))) * 100 + 111;
            let min2 = 1;
            let max2 = list.length - 300;
            let rand2 = Math.round((min2 + (Math.random() * (max2 - min2)))); // Chọn mã CK
            let min3 = 1;
            let max3 = 10;
            let rand3 = Math.round((min3 + (Math.random() * (max3 - min3)))); // Số lượng listProperty thay đổi
            let listProperty = ['CP', 'U1', 'U2', 'U3', 'P1', 'P2', 'P3', 'B1', 'B2', 'B3', 'V1', 'V2', 'V3', 'S1', 'S2', 'S3', 'P4A', 'percent', 'SI', 'FN', 'TD', 'FC', 'ST', 'CL', 'FL', 'RE', 'CV', 'CH', 'TT', 'TV', 'AP', 'OP', 'HI', 'LO', 'FB', 'FS', 'FR', 'EX', 'OI', 'LTD', 'ULS', 'IN', 'MD', 'CHP', 'EP', 'FO', 'PMP', 'PMQ', 'PTQ', 'PTV', 'PP', 'TO', 'TB']
            let min4 = 0;
            let max4 = listProperty.length;
            // let listProperty = ['CP', 'U1', 'U2', 'U3', 'B1', 'B2', 'B3', 'V1', 'V2', 'V3', 'S1', 'S2', 'S3']
            let SB = list[Math.floor(Math.random() * (list.length - 1))]
            // SB = "AAA" // HOSE
            // SB= "ACB" // VN30
            // SB= "ACB" // HOSE
            // SB = "AAV" // HNX
            // SB= "AAH" // UPCOM
            // SB= "GB05F2409" // PS
            // SB= "CACB2304" // CQ
            // SB= "E1VFVN30" // ETF
            // SB= "AAA12101" // TPRL
            countSeqTest[SB] = countSeqTest[SB] !== undefined ? countSeqTest[SB] + 1 : 100 // START SEQ từ 100
            let instrument: any = [{
                // t: 1966682910000,
                SB,
                CP: parseInt((rand.toString()).split(".")[0]),
                // RE:  parseInt((rand.toString()).split(".")[0]),
                // CL:  parseInt((rand.toString()).split(".")[0])+10000,
                // FL:  parseInt((rand.toString()).split(".")[0])-10000,
                // FMP: SB == "ACB" ? 28750 : 33550,
                // FMP: parseInt((rand.toString()).split(".")[0]),
                // FV: 1000000,
                // FV: parseInt((rand.toString()).split(".")[0]),
                // UT: 1715753739209,
                // CV: parseInt((rand.toString()).split(".")[0]),
                // V1: parseInt((rand.toString()).split(".")[0]),
                // B1: parseInt((rand.toString()).split(".")[0]),
                // CP: parseInt((rand.toString()).split(".")[0]),
                // PTV: parseInt((rand.toString()).split(".")[0]),
                s: new Date().getTime(),
            }]
            for (let i = 0; i < rand3; i++) {
                let rand4 = Math.round((min4 + (Math.random() * (max4 - min4)))); // Số lượng listProperty
                // alert(rand4)
                if (listProperty[rand4] !== "CP") {
                    instrument[0][listProperty[rand4]] = parseInt((rand.toString()).split(".")[0])
                }
            }

            let data = instrument
            store.dispatch(updateInstruments(data));
            store.dispatch(updateInstrumentsDict(data));
            // console.log("updateInstruments.:socket", data)
            data = null
            instrument = null
            return null
        }, 5000)
    }
}, 3000)
